// import FleetrifyCard from "../../components/Card";
// import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
// import {
//   optionIcon,
// } from "../../components/pages/Dashboard/items";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Filler,
//   Legend,
// } from "chart.js";
// import { Line } from "react-chartjs-2";
// import TransactionHistoryTable from "../../components/Table/TransactionHistoryTable";
// import WalletActivityChart from "../../components/pages/Dashboard/Chart/WalletActivityChart";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Filler,
//   Legend
// );
// const WalletOverview = () => {
//  const data = {
//    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//    datasets: [
//      {
//        label: "Financial Trend",
//        data: [35, 60, 50, 65, 60, 70], // example data
//        fill: true,
//        backgroundColor: "rgba(66, 133, 244, 0.1)",
//        borderColor: "rgba(66, 133, 244, 1)",
//        tension: 0.4,
//      },
//    ],
//  };

//  const options = {
//    responsive: true,
//    plugins: {
//      legend: { display: false },
//    },
//    scales: {
//      y: {
//        ticks: {
//          callback: (value: number | string) => `$${value}`,
//        },
//        beginAtZero: false,
//      },
//    },
//  };
//   return (
//     <div className="">
//       {/* summary card group */}
//       <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
//         <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//           <DashboardFleetSummaryCard
//             // title="Total Spent This Month"
//             title="Total Withdrawals"

//             value={"₦132,000"}
//             changeText="20% 18 Transactions"
//             changeDirection="up"
//           />
//           <DashboardFleetSummaryCard
//             title="Pending Withdrawals"
//             value={"₦20,000"}
//             changeText="8% 2 Requests"
//             changeDirection="up"
//           />
//           <DashboardFleetSummaryCard
//             title="Successful Withdrawals"
//             value={"₦50,000"}
//             changeText="25% June 27, 2025 – Paystack"
//             changeDirection="down"
//           />
//         </div>
//       </section>
//       {/* Financial  trend */}
//       <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
//         <div className="flex justify-between items-center pb-5">
//           <div>
//             <h3 className="text-lg font-semibold text-[#00032A]">
//               Financial Trend
//             </h3>
//             <p className="text-xs text-[#4F4F4F] italic">(in millions)</p>
//           </div>
//           <button>{optionIcon}</button>
//         </div>
//         {/* Chart */}
//         <div className="bg-white rounded-lg p-4">
//           <Line
//             key="financialTrendChart"
//             data={data}
//             options={options}
//             height={100}
//           />
//         </div>
//       </section>
//       <section
//         className={`flex flex-col lg:flex-row gap-4 w-full h-full justify-between relative mt-8`}
//       >
//         <div className="flex-[2]">
//           <FleetrifyCard cardContainerClass="!p-0">
//             <div className="flex px-6 sticky top-0 py-4 justify-between items-center ">
//               <div>
//                 <h3 className="text-lg font-semibold text-[#00032A]">
//                   Transactions History
//                 </h3>
//               </div>
//               <button>{optionIcon}</button>
//             </div>
//             <div className="overflow-y-scroll hide-scrollbar">
//               <TransactionHistoryTable />
//             </div>
//           </FleetrifyCard>
//         </div>
//         <div className="flex-1">
//           <FleetrifyCard cardContainerClass="!p-0">
//             <div className="flex px-6 sticky top-0 py-4 justify-between items-center ">
//               <div>
//                 <h3 className="text-lg font-semibold text-[#00032A]">
//                   Wallet Activity Chart
//                 </h3>
//                 <p className="text-xs text-[#4F4F4F] italic">
//                   For selected period
//                 </p>
//               </div>
//               <button>{optionIcon}</button>
//             </div>
//             {/* Activity chart */}
//             <div className="flex justify-end w-full items-center max-w-full">
//               <WalletActivityChart />
//             </div>
//           </FleetrifyCard>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default WalletOverview;



import FleetrifyCard from "../../components/Card";
import { DashboardFleetSummaryCard } from "../../components/pages/Dashboard/Cards/summary";
import { optionIcon } from "../../components/pages/Dashboard/items";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import TransactionHistoryTable from "../../components/Table/TransactionHistoryTable";
import WalletActivityChart from "../../components/pages/Dashboard/Chart/WalletActivityChart";
// import { useGetWalletSummaryQuery } from "../../redux/api/walletApi";
import { useGetWalletSummaryQuery } from "../../redux/services/Wallet";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const WalletOverview = () => {
  const { data: summaryResponse, isLoading } = useGetWalletSummaryQuery();

  const summary = summaryResponse?.data;

  const ALL_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const trendMap = Object.fromEntries((summary?.financial_trend ?? []).map((d) => [d.month, d.total]));

  const financialTrendData = {
    labels: ALL_MONTHS,
    datasets: [
      {
        label: "Total (₦)",
        data: ALL_MONTHS.map((m) => trendMap[m] ?? 0),
        backgroundColor: ALL_MONTHS.map((m) => trendMap[m] ? "rgba(66, 133, 244, 0.8)" : "rgba(66, 133, 244, 0.2)"),
        borderRadius: 4,
        borderSkipped: false,
        maxBarThickness: 48,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx: { parsed: { y: number } }) =>
            `₦${ctx.parsed.y.toLocaleString()}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: number | string) =>
            `₦${Number(value).toLocaleString()}`,
        },
      },
    },
  };

  const totalW   = summary?.total_withdrawals;
  const pendingW = summary?.pending_withdrawals;
  const successW = summary?.successful_withdrawals;

  return (
    <div className="">
      {/* Summary card group */}
      <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
        <h3 className="text-sm font-semibold text-[#00032A] mb-4">Summary</h3>
        {isLoading ? (
          <p className="text-sm text-gray-400">Loading summary...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <DashboardFleetSummaryCard
              title="Total Transactions"
              value={`₦${totalW?.amount ?? "0.00"}`}
              changeText={`${totalW?.count ?? 0} Transactions`}
              changeDirection="up"
            />
            <DashboardFleetSummaryCard
              title="Pending Transactions"
              value={`₦${pendingW?.amount ?? "0.00"}`}
              changeText={`${pendingW?.count ?? 0} Requests`}
              changeDirection="up"
            />
            <DashboardFleetSummaryCard
              title="Successful Transactions"
              value={`₦${successW?.amount ?? "0.00"}`}
              changeText={
                successW?.last_date
                  ? `${successW.last_date}${successW.channel ? ` – ${successW.channel}` : ""}`
                  : `${successW?.count ?? 0} Transactions`
              }
              changeDirection="down"
            />
          </div>
        )}
      </section>

      {/* Financial Trend */}
      <section className="bg-[#E7E9EE] p-4 rounded-lg mt-10">
        <div className="flex justify-between items-center pb-5">
          <div>
            <h3 className="text-lg font-semibold text-[#00032A]">
              Financial Trend
            </h3>
            <p className="text-xs text-[#4F4F4F] italic">(in millions)</p>
          </div>
          <button>{optionIcon}</button>
        </div>
        <div className="bg-white rounded-lg p-4 w-full" style={{ position: "relative", height: "260px" }}>
          <Bar
            key="financialTrendChart"
            data={financialTrendData}
            options={{ ...options, maintainAspectRatio: false }}
          />
        </div>
      </section>

      {/* Transactions + Activity Chart */}
      <section className="flex flex-col lg:flex-row gap-4 w-full h-full justify-between relative mt-8">
        <div className="flex-[3]">
          <FleetrifyCard cardContainerClass="!p-0">
            <div className="flex px-6 sticky top-0 py-4 justify-between items-center">
              <h3 className="text-lg font-semibold text-[#00032A]">
                Transactions History
              </h3>
              <button>{optionIcon}</button>
            </div>
            <div className="overflow-y-auto hide-scrollbar">
              <TransactionHistoryTable />
            </div>
          </FleetrifyCard>
        </div>
        <div className="flex-1">
          <FleetrifyCard cardContainerClass="!p-0">
            <div className="flex px-6 sticky top-0 py-4 justify-between items-center">
              <div>
                <h3 className="text-lg font-semibold text-[#00032A]">
                  Wallet Activity Chart
                </h3>
                <p className="text-xs text-[#4F4F4F] italic">
                  For selected period
                </p>
              </div>
              <button>{optionIcon}</button>
            </div>
            <div className="flex justify-end w-full items-center max-w-full">
              <WalletActivityChart activityData={summary?.wallet_activity ?? []} />
            </div>
          </FleetrifyCard>
        </div>
      </section>
    </div>
  );
};

export default WalletOverview;